import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import { CloseIcon } from "@icarius-icons";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { getLocalizedString } from "@icarius-localization/strings";
import DialogTransition from "@icarius-common/dialogTransition";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const CommentDialog = (props) => {

    const {
        open,
        handleChange,
        handleClose,
    } = props;

    const [value, setValue] = useState("");

    const handleSubmit = () => {
        handleChange(value);        
        handleClose();
    }

    return (
        <Dialog
            TransitionComponent={DialogTransition}
            open={open}
            PaperComponent={PaperDraggable}
            maxWidth={'sm'}
            fullWidth
            onClose={handleClose}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {getLocalizedString("calibration")}
                <DialogTitleDivider />
            </DialogTitle>
            <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
            <DialogContent>
                <TextFieldMultiline
                    autoFocus
                    fullWidth
                    margin={"none"}
                    label={getLocalizedString("calibrationComments")}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSubmit();
                        }
                    }}
                    rows={4}
                />
            </DialogContent>
            <DialogActions>
                <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
                <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("save")} />
            </DialogActions>
        </Dialog>
    )
}

export default CommentDialog;
